export default __webpack_public_path__ + "static/media/yotta21-dark-mode-6682.c617bab0.svg";